module.exports = "https://coursera_assets.s3.amazonaws.com/images/7c74a9da517322d1fca6d38cc631cc11.png";